import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CustomerDetailRequestBody, CustomerDetailResponse } from "./types";

export class CustomerDetailAPI extends BaseAPI<
  CustomerDetailRequestBody,
  CustomerDetailResponse
> {
  protected route = ApiRoutes.customer.detail;
  protected method = RequestMethod.GET;
  protected params = ["customerId"];
}
